import React from "react"

function TeamB() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={110}
        y={28}
        width={46}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect x={87} y={37} width={92} height={4} rx={2} fill="var(--base-500)" />
      <path
        d="M36.111 83H50.89A2.111 2.111 0 0053 80.889V66.11A2.111 2.111 0 0050.889 64H36.11A2.111 2.111 0 0034 66.111V80.89a2.11 2.11 0 002.111 2.111zm0 0l11.611-11.611L53 76.667m-11.611-6.861a1.583 1.583 0 11-3.167 0 1.583 1.583 0 013.167 0z"
        stroke="var(--base-500)"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={66}
        y={65}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <path
        d="M66 73.5a1.5 1.5 0 011.5-1.5h48a1.5 1.5 0 010 3h-48a1.5 1.5 0 01-1.5-1.5zm0 7a1.5 1.5 0 011.5-1.5h53a1.5 1.5 0 010 3h-53a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M147.111 83h14.778A2.111 2.111 0 00164 80.889V66.11a2.111 2.111 0 00-2.111-2.11h-14.778A2.111 2.111 0 00145 66.111V80.89a2.11 2.11 0 002.111 2.111zm0 0l11.611-11.611L164 76.667m-11.611-6.861a1.583 1.583 0 11-3.167 0 1.583 1.583 0 013.167 0z"
        stroke="var(--base-500)"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={177}
        y={65}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <path
        d="M177 73.5a1.5 1.5 0 011.5-1.5h48a1.5 1.5 0 010 3h-48a1.5 1.5 0 01-1.5-1.5zm0 7a1.5 1.5 0 011.5-1.5h53a1.5 1.5 0 010 3h-53a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M36.111 121H50.89a2.111 2.111 0 002.11-2.111v-14.778A2.111 2.111 0 0050.889 102H36.11a2.111 2.111 0 00-2.11 2.111v14.778A2.11 2.11 0 0036.111 121zm0 0l11.611-11.611L53 114.667m-11.611-6.861a1.583 1.583 0 11-3.167 0 1.583 1.583 0 013.167 0z"
        stroke="var(--base-500)"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={66}
        y={103}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <path
        d="M66 111.5a1.5 1.5 0 011.5-1.5h48a1.5 1.5 0 010 3h-48a1.5 1.5 0 01-1.5-1.5zm0 7a1.5 1.5 0 011.5-1.5h53a1.5 1.5 0 010 3h-53a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M147.111 121h14.778a2.11 2.11 0 002.111-2.111v-14.778a2.11 2.11 0 00-2.111-2.111h-14.778a2.11 2.11 0 00-2.111 2.111v14.778a2.11 2.11 0 002.111 2.111zm0 0l11.611-11.611 5.278 5.278m-11.611-6.861a1.583 1.583 0 11-3.167 0 1.583 1.583 0 013.167 0z"
        stroke="var(--base-500)"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={177}
        y={103}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <path
        d="M177 111.5a1.5 1.5 0 011.5-1.5h48a1.5 1.5 0 010 3h-48a1.5 1.5 0 01-1.5-1.5zm0 7a1.5 1.5 0 011.5-1.5h53a1.5 1.5 0 010 3h-53a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
    </svg>
  )
}

export default TeamB;
